import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("aa_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${(x.loc || []).slice(-1)[0]}: ${x.msg}` : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}?auth=${localStorage.getItem("aa_token") || ""}`;
}

export async function uploadFile(file, isPublic = false) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("public", isPublic ? "true" : "false");
  const { data } = await api.post("/files/upload", fd);
  return data;
}

export async function download(url, filename) {
  let data;
  try {
    ({ data } = await api.get(url, { responseType: "blob" }));
  } catch (e) {
    const b = e?.response?.data;
    if (b instanceof Blob) {
      try { e.response.data = JSON.parse(await b.text()); } catch { /* not JSON */ }
    }
    throw e;
  }
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" })}`;
export const rateOf = (doc, fallback) => (doc?.tax_rate === undefined || doc?.tax_rate === null || doc?.tax_rate === "" ? Number(fallback || 0) : Number(doc.tax_rate));
export const todayIso = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });
export const fmtDate = (d) => {
  if (!d) return "";
  const x = new Date(d.length === 10 ? d + "T12:00:00" : d);
  return isNaN(x) ? "" : `${String(x.getDate()).padStart(2, "0")}/${String(x.getMonth() + 1).padStart(2, "0")}/${x.getFullYear()}`;
};
